import { Tooltip } from '@mui/material';
import { MIconButton } from '../../../components/@material-extend';
import useAuth from '../../../hooks/useAuth';
import DoneAllIcon from '@mui/icons-material/DoneAll';
export const MarkAllasReadByRol = ({ rol, onClickMarkAllAsReadAdvisor, onClickMarkAllAsReadAffiliate, loadingAllMarket }) => {


    const { businessData } = useAuth();
   
   
    const Affiliations = businessData?.affiliationData?.map((e) => {
        return   e?.affiliationDataId 
    });


    return (


        <Tooltip title="Marcar todos como leídos">
            <MIconButton color="primary" onClick={() => {

                if (rol.includes("AFFILIATE")) {
                    onClickMarkAllAsReadAffiliate({ Affiliations, Notification: true });
                }

                if (rol.includes("ADVISOR") || rol.includes("SUPERVISOR") || rol.includes("MONEYGUARD") || rol.includes("MONEYGUARDADMINISTRATOR") || rol.includes("TECHNICIANADMINISTRATOR") || rol.includes("TECHNICIAN")) {
                    onClickMarkAllAsReadAdvisor({ Notification: true, Request: true });
                }

            }

            }>

                {loadingAllMarket && "la"}
                <DoneAllIcon style={{ width:20,height:20}}  />
               
               
            </MIconButton>
        </Tooltip>


    )
}

